import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { USFlag, ToggleBaseNo, ToggleBaseYes } from "../../../../public/assets";
import AccountBalanceInput from "../../../components/Accounts/AccountBalanceInput";
import Layout from "../../../components/Accounts/Layout";
import SaveBeneficiaryComponent from "../../../components/Accounts/SaveBeneficiaryComponent";
import TransactionFeeContainer from "../../../components/Accounts/TransactionFeeContainer";
import { InputItem } from "../data";
import InputContainer from "../../../components/Accounts/InputContainer";
import Button from "../../../components/Button/Button";
import { colors } from "../../../theme/color";
import fipayFonts from "../../../theme/index";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useMutation, useQuery } from "@apollo/client";
import {
  fetchBeneficiaryDetails,
  getUserBankDetails,
  getUserNameByTag,
} from "../../../graphql/queries/accounts";
import { saveBeneficiary } from "../../../graphql/mutations/accounts";
import {
  getAccountConfiguration,
  GetAccountConfigurationResponse,
} from "../../../utils/getAccountConfig";
import { setFormValues } from "../../../store/formValues";
import SelectBeneficiary from "../FipayTransfer/SelectBeneficiary";
import { payAnyOneInputs } from "./data";

interface PaymentDetailsProps {
  handleNext: (step: number) => void;
  prevValues: InputItem[];
  transferType: string;
}

const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  handleNext,
  prevValues,
  transferType,
}) => {
  const dispatch = useDispatch();
  const id = useSelector((state: RootState) => state.user?.user?.id);
  const formValues = useSelector(
    (state: RootState) => state.formValues.payAnyOne
  );
  const [showSelectBeneficiary, setShowSelectBeneficiary] = useState(false);
  const [activeType, setActiveType] = useState<string>("");
  const [recipientTag, setRecipientTag] = useState("");
  const [beneficiaryIsSaved, setBeneficiaryIsSaved] = useState(false);
  const [saveBeneficiaryMutation, { loading, error, data }] =
    useMutation(saveBeneficiary);
  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useQuery(getUserNameByTag, {
    variables: { tag: recipientTag },
  });

  const userName = queryData?.getUserNameByTag || "";

  const handleChooseBeneficiaryClick = () => {
    setShowSelectBeneficiary(!showSelectBeneficiary);
  };

  const handleClose = () => {
    setShowSelectBeneficiary(false);
  };
  const handleSelectBeneficiary = (value: string) => {
    setActiveType(value);
    setShowSelectBeneficiary(false);
  };
  const handleSaveToggle = async () => {
    setBeneficiaryIsSaved((prevState) => !prevState);
    try {
      const { data } = await saveBeneficiaryMutation({
        variables: {
          // userId: id,
          options: {
            recipientPhoneNumber: formValues?.RecipientPhoneNumber,
            recipientFullName: formValues?.RecipientFullName,
          },
        },
      });
      console.log("Beneficiary saved successfully!", data);
    } catch (error) {
      console.error("Error saving beneficiary:", error);
    }
  };
  // const {
  //   loading: userBankQuery,
  //   data: userBankQueryData,
  //   refetch: refetchUserBank,
  // } = useQuery(getUserBankDetails, {
  //   variables: { getUserBankDetailsId: id },
  // });

  // const financeDetails = userBankQueryData?.getUserBankDetails || "";

  // const amountValue = financeDetails?.userFinancialDetails?.available || 0;
  // const hasTransactionHistory = financeDetails?.transactions?.length > 0;

  const {
    loading: userBankQuery,
    data: userBankQueryData,
    refetch: refetchUserBank,
  } = useQuery(getUserBankDetails);

  const financeDetails = userBankQueryData?.getUserBankDetails || "";

  const amountValue = financeDetails?.userFinancialDetails?.available || 0;

  useEffect(() => {
    refetchUserBank();
  }, [id]);

  const [config, setConfig] =
    React.useState<GetAccountConfigurationResponse | null>(null);
  React.useEffect(() => {
    (async () => {
      const data = await getAccountConfiguration();
      setConfig(data);
    })();
  }, []);

  useEffect(() => {
    if (activeType) {
      setRecipientTag(activeType);
    }
  }, [activeType]);

  const transactionFee = config?.transactionFee?.toFipayUser || 0;
  return (
    <Layout>
      <AccountBalanceInput
        icon="/assets/icons/usFlag.svg"
        currencyTitle={"USD Balance"}
        amountValue={amountValue}
        currency={"$"}
        label={"Balance to send from"}
      />
      {showSelectBeneficiary && (
        <SelectBeneficiary
          slideIn={true}
          onClose={handleClose}
          activeType={activeType}
          onTypeChange={handleSelectBeneficiary}
          transferType={"payAnyone"}
        />
      )}
      <Formik
        initialValues={{
          RecipientPhoneNumber: formValues?.RecipientPhoneNumber || "",
          Amount: formValues?.Amount || "",
          RecipientFullName: formValues?.RecipientFullName || "",
          Purpose: formValues?.Purpose || "",
        }}
        validationSchema={Yup.object({
          RecipientPhoneNumber: Yup.string().required("Required"),
          RecipientFullName: Yup.string().required("Required"),
          Amount: Yup.number()
            .min(5, "Amount must be greater than or equal to $5")
            .max(
              amountValue,
              `Amount must be less than or equal to ${amountValue}`
            )
            .required("Required"),
        })}
        onSubmit={(values) => {
          try {
            if (+values.Amount > amountValue) {
              throw new Error("Amount cannot exceed available balance");
            }
            handleNext(1);
            const formData = {
              ...values,
              TransactionType: "Pay Anyone",
              TransactionFee: transactionFee,
              beneficiaryIsSaved,
            };
            dispatch(setFormValues({ [transferType]: formData }));
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <>
              {payAnyOneInputs.map((input, index) => (
                <InputAndTransactionFeeWrapper key={index}>
                  <InputContainer
                    name={input.name}
                    label={input.label}
                    type={input.type}
                    placeholder={input.placeholder}
                    hasPrefix={input.placeholder !== ""}
                    value={
                      input.name === "RecipientFullName" ||
                      input.name === "RecipientPhoneNumber"
                        ? activeType
                          ? activeType
                          : formik.values[
                              input.name as keyof typeof formik.values
                            ] || ""
                        : formik.values[
                            input.name as keyof typeof formik.values
                          ] || ""
                    }
                    onChange={(e) => {
                      formik.handleChange(e);
                      if (input.name === "RecipientTag") {
                        setRecipientTag(e.target.value);
                        setActiveType(e.target.value);
                      }
                    }}
                    width={"100%"}
                    error={
                      formik.touched[
                        input.name as keyof typeof formik.touched
                      ] &&
                      formik.errors[input.name as keyof typeof formik.errors]
                    }
                  />

                  {input.hasBeneficiary && !userName && (
                    <Beneficiary onClick={handleChooseBeneficiaryClick}>
                      Choose Beneficiary
                    </Beneficiary>
                  )}
                  {input.hasTransactionFee && (
                    <TransactionFeeContainer
                      transactionFee={formik.values.Amount ? transactionFee : 0}
                      currency={"$"}
                      style={{ marginLeft: "auto" }}
                    />
                  )}
                </InputAndTransactionFeeWrapper>
              ))}
              <SaveBeneficiaryComponent
                toggleIcon={
                  beneficiaryIsSaved
                    ? "/assets/svg/ToggleBaseYes.svg"
                    : "/assets/svg/ToggleBaseNo.svg"
                }
                Title={
                  beneficiaryIsSaved
                    ? "Beneficiary Saved"
                    : "Save as beneficiary"
                }
                onClick={handleSaveToggle}
              />
            </>
            <Button
              id={""}
              type="submit"
              padding={"10px 45%"}
              title={"Next"}
              border="10px"
              green
              disabled={!formik.isValid || !formik.dirty}
            />
          </form>
        )}
      </Formik>
    </Layout>
  );
};

export default PaymentDetails;

export const InputAndTransactionFeeWrapper = styled.div`
  padding-bottom: 2rem;
  .hidden {
    visibility: hidden;
  }
`;

export const Beneficiary = styled.span`
  color: ${colors.GREEN};
  display: block;
  margin-bottom: 5px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  letter-spacing: 2%;
  text-align: right;
  cursor: pointer;
`;
export const AccountName = styled.span`
  display: flex;
  justify-content: flex-end;
`;
export const ErrorMessage = styled.span`
  color: #b00020;
`;
